import { useEventLogging } from '@AppModels/Logging';
import { css } from 'aphrodite';
import { useHistory } from 'react-router-dom';
import { MastheadPortalId } from '../../../../models/AdminModels';
import { NavigationBreadcrumbsBar } from '../../../../web/components/NavigationBreadcrumbsBar';
import { Portal } from '../../../../web/components/Portal';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { AutomationTemplatesByIndustry } from '../AutomationTemplatesByIndustry';
import { IndustryTemplates } from '../IndustryTemplates';
import { IndustryTemplatesCreateButton } from '../IndustryTemplates/prensentation';
import { styleSheet } from './styles';

export function AutomationTemplates() {
	const { logEvent } = useEventLogging();
	const history = useHistory();
	const onCreateEmailTemplateClicked = () => {
		logEvent('CreateTemplate');
		history.push('/automations/new');
	};

	return (
		<div className={`${css(styleSheet.container)} automation-templates`}>
			<Portal destination={MastheadPortalId}>
				<NavigationBreadcrumbsBar />
			</Portal>
			<IndustryTemplates
				onRenderTemplatesByIndustryRoute={(industry, props) => (
					<AutomationTemplatesByIndustry {...props} industry={industry} />
				)}
			>
				<IndustryTemplates.ActionBarHeader>
					<div className={css(baseStyleSheet.horizontalStack, styleSheet.createButtons)}>
						<IndustryTemplatesCreateButton onClick={onCreateEmailTemplateClicked}>
							Automation
						</IndustryTemplatesCreateButton>
					</div>
				</IndustryTemplates.ActionBarHeader>
			</IndustryTemplates>
		</div>
	);
}
